import type React from 'react';
import { Card as TailGridsCard, CardHeader, CardTitle } from '../tailgrids/core/card.js';
import { cn } from '../../utils/cn.js';

interface CardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  /** Controls on the right of the title row — an `ActionMenu` (⋯), a period select, a link. */
  actions?: React.ReactNode;
}

/**
 * A content panel — NextAdmin's dashboard widget card (`(dashboard)/(home)/_component/top-products`,
 * `traffic-sources`, `tables/basic-tables/_component/leads-report`): padded card, title row with its controls, then the
 * content with no divider.
 */
export function Card({ title, children, className, actions }: CardProps) {
  return (
    <TailGridsCard className={className}>
      {(title || actions) && (
        <CardHeader className="mb-6">
          {title && <CardTitle level={3}>{title}</CardTitle>}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </CardHeader>
      )}
      <div className={cn('min-w-0')}>{children}</div>
    </TailGridsCard>
  );
}
